module.exports.config = {
  "declarative": true,
  "render-module": {
    "name": "PieceLottieRenderModule",
    "path": "front/piece-lottie-render.module"
  },
  "definition": {
    "type": "pieceLottie",
    "name": "PieceLottieDefinition",
    "group": "Components",
    "availablePlatforms": ["web"],
    "description": "Lottie",
    "isNew": false,
    "fields": [
      {
        "name": "animationName",
        "label": "Nombre de la animación",
        "type": "plainText",
        "mandatory": true
      },
      {
        "name": "effect",
        "label": "Efecto",
        "type": "options",
        "defaultValue": "loop",
        "values": [
          { 
            "value": "loop", 
            "label": "Loop" 
          },
          { 
            "value": "once", 
            "label": "Once" 
          }
        ]
      },
      {
        "name": "speed",
        "label": "Velocidad de la animación",
        "type": "plainText",
        "defaultValue": "1",
        "mandatory": true,
        "validators": ["positiveInteger"]
      },
    ]
  }
};
